import React from 'react';
import { connect } from 'react-redux';
import { TableRow, TableCell } from '@material-ui/core';
import moment from 'moment';
import Datatable from '../../../../partials/datatable/Datatable';
import { CapsulesApiService } from '../../../../services/Ananse/CapsulesApiService';

class CapsulesListing extends React.Component {
  constructor(props) {
    super(props);

    this.api = new CapsulesApiService();
    this.setCapsules = this.setCapsules.bind(this);
  }

  state = {
    capsules: [],
    reload: false
  };

  setCapsules(capsules) {
    this.setState({ capsules });
  }

  render() {
    window.setPageTitle(`${this.props.translate.screens.capsule?.title || 'Capsule'} - Admin`);

    const headRows = [
      { column: 'SerialNumber', label: this.props.translate.screens.capsule?.labels?.serial },
      { column: 'Fragrance.Name', label: this.props.translate.screens.fragrance?.list?.title },
      { column: 'RemainingShots', label: this.props.translate.screens.capsule?.labels?.remaining },
      { column: 'Device.MacAddress', label: this.props.translate.screens.device?.labels?.macAddress },
      { column: 'DueDate', label: this.props.translate.screens.capsule?.labels?.dueDate },
      { column: 'CreatedAt', label: this.props.translate.screens.quiz.list.created },
      { column: 'UpdatedAt', label: this.props.translate.screens.quiz.list.updated }
    ];

    const formatRow = r => (
      <TableRow
        hover
        tabIndex={-1}
        key={r.deviceId}
      >
        <TableCell scope="row">
          {r.serialNumber}
        </TableCell>
        <TableCell scope="row">
          {r.fragrance?.name}
        </TableCell>
        <TableCell scope="row">
          {r.remainingShots}
        </TableCell>
        <TableCell scope="row">
          {r.device?.macAddress}
        </TableCell>
        <TableCell scope="row">
          {moment(r.dueDate).format('DD/MM/YYYY HH:mm')}
        </TableCell>
        <TableCell scope="row">
          {moment(r.createdAt).format('DD/MM/YYYY HH:mm')}
        </TableCell>
        <TableCell scope="row">
          {moment(r.updatedAt).format('DD/MM/YYYY HH:mm')}
        </TableCell>
      </TableRow>
    );

    return (
      <Datatable
        title={this.props.translate.screens.capsule?.title}
        endpoint='/capsules'
        headRows={headRows}
        formatRow={formatRow}
        rows={this.state.capsules}
        setRows={this.setCapsules}
        reload={this.state.reload}
        placeholderSearch={this.props.translate.screens.capsule?.placeholders?.filter}
      />
    );
  }
}

const mapStoreToProps = store => ({
  i18n: store.i18n
});

export default connect(mapStoreToProps, null)(CapsulesListing);
